<template>
  <div class="page modal-page-scroll d-flex flex-column">
    <div class="row header-page w-100">
      <div class="col-12 mb-4">
        <h3>
          Tutela: assicurazioni facoltative complementari
        </h3>
      </div>
      <div class="col-12 ">
        <div class="d-flex pb-3 mb-5 flex-row">
          <div class="">
            <img
              :src="require('../../assets/images/banner/05/05-cross-02.svg')"
              style="width: 280px"
            />
          </div>
          <div class="d-flex flex-column w-100">
            <div class="h4-medium mb-2">
              Temporanea caso morte accidentale (ACMA-IS)
            </div>
            <div class="Subhead-14">
              Garantisci ai tuoi cari un sostegno economico in caso di perdita
              causata da infortunio. Il capitale garantito sarà raddoppiato se
              la perdita derivasse da infortunio stradale. E per gli iscritti al
              programma fedeltà Più Generali è previsto un aumento del capitale
              assicurato.
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="false">
        <div class="d-flex pb-3 mb-5 flex-row">
          <div class="">
            <img
              :src="require('../../assets/images/banner/05/05-cross-03.svg')"
              style="width: 280px"
            />
          </div>
          <div class="d-flex flex-column w-100">
            <div class="h4-medium mb-2">
              Family Care
            </div>
            <div class="Subhead-14">
              Iscrivendoti al programma di fedeltà Più Generali potrai offrire
              ai tuoi affetti più cari una protezione particolare nel caso in
              cui un evento imprevedibile dovesse cagionare la prematura
              scomparsa di due componenti del nucleo familiare.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SdgData } from "../../data/sdg.data";
export default {
  name: "ExtraProtectionInfo",
  data: () => {
    return {
      sdgList: []
    };
  },
  created() {
    this.sdgList = SdgData;
  }
};
</script>

<style scoped></style>
